import {gql, useMutation} from "@apollo/client";

const ADD_STAGE_PLAY_DAY_MUTATION = gql`
mutation CreateStagePlayDayMutation($stageId: Int!, $day: String!, $fromTime: String!, $timezone: String!) {
  createStagePlayDay(stageId: $stageId, day: $day, fromTime: $fromTime, timezone: $timezone) {
     stagePlayDay{
        id
        day
        fromTime
        timezone
     }
  }
}
`;

export default function AddStagePlayDayMutation() {
    return useMutation(ADD_STAGE_PLAY_DAY_MUTATION);
}